import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { StaticImage } from "gatsby-plugin-image";

const navLinks = [
  { name: "Home", path: "/" },
  { name: "Gallery", path: "/gallery" },
  { name: "Certifications", path: "/certifications" },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md py-3 shadow-md border-b border-primary-100" : "bg-transparent py-6"
      }`}
    >
      <div className="container mx-auto px-6 flex justify-between items-center">
        <Link to="/" className="tracking-widest flex items-center gap-3">
          <span className="font-serif text-2xl md:text-3xl tracking-widest text-primary-900">
            Dilshani Wettasinghe
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-10">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`text-sm uppercase tracking-[0.2em] font-medium transition-colors ${
                scrolled ? "text-primary-800 hover:text-accent-500" : "text-primary-800 hover:text-accent-500 bg-white/50 px-3 py-1 rounded-full backdrop-blur-sm"
              }`}
              activeClassName="text-accent-500 font-bold"
            >
              {link.name}
            </Link>
          ))}
        </nav>

        {/* Mobile Nav Button */}
        <button
          className="md:hidden text-primary-800 focus:outline-none bg-white/50 p-2 rounded-full backdrop-blur-sm"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden absolute top-full left-0 w-full bg-white/95 backdrop-blur-xl border-t border-primary-100 shadow-xl"
          >
            <nav className="flex flex-col items-center py-10 space-y-8">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="text-xl text-primary-800 hover:text-accent-500 font-serif tracking-widest"
                  onClick={() => setIsOpen(false)}
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
